import { Box, Typography, Container, IconButton, Card } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import oats from '../../Assets/oats.png';
import { useNavigate } from 'react-router-dom';

export default function OrderPlaced() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#f8f9fa',
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '400px',
        margin: '0 auto',
        position: 'relative',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          py: 2.5,
          px: 2,
          mt: 1,
        }}
      >
        <IconButton
          sx={{
            position: 'absolute',
            left: 20,
            color: '#000',
            p: 0,
          }}
          aria-label="Go back"
          onClick={() => navigate('/top-picks')}
        >
          <ArrowBackIcon sx={{ fontSize: 24 }} />
        </IconButton>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: '#000',
            fontSize: '20px',
          }}
        >
          Order Placed
        </Typography>
      </Box>

      <Container
        maxWidth="sm"
        sx={{
          flex: 1,
          px: 3,
          pb: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Card
          sx={{
            borderRadius: '28px',
            mb: 6,
            width: '100%',
            backgroundColor: 'white',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            border: '1px solid #f0f0f0',
          }}
        >
          {/* <Box
            sx={{
              py: 2.5,
              px: 3,
              textAlign: "center",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: "#000",
                fontSize: "16px",
                fontWeight: 500,
              }}
            >
              John Doe, Room no. 113
            </Typography>
          </Box> */}
        </Card>

        <Box
          sx={{
            mb: 4,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CheckCircleIcon
            sx={{
              fontSize: 120,
              color: '#4caf50',
            }}
          />
        </Box>

        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            fontSize: '28px',
            color: '#000',
            mb: 2,
            textAlign: 'center',
          }}
        >
          Payment Confirmed
        </Typography>

        {/* <Typography
          variant="body1"
          sx={{
            color: "#666",
            fontSize: "16px",
            mb: 6,
            textAlign: "center",
          }}
        >
          Your Food Will be reached in 30 mins
        </Typography> */}

        {/* <Card
          sx={{
            borderRadius: "20px",
            width: "100%",
            backgroundColor: "white",
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            border: "1px solid #f0f0f0",
          }}
        >
          <Box
            sx={{
              p: 3,
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: "50%",
                backgroundImage: `url(${oats})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                flexShrink: 0,
              }}
            />

            <Box sx={{ flex: 1 }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: "16px",
                  color: "#000",
                  mb: 1,
                  lineHeight: 1.3,
                }}
              >
                Oatmeal with Nuts and Seeds
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: "20px",
                  color: "#000",
                  mb: 1,
                }}
              >
                $20
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: "#666",
                  fontSize: "14px",
                  fontWeight: 500,
                }}
              >
                Order Confirmed
              </Typography>
            </Box>
          </Box>
        </Card> */}
      </Container>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          pb: 2,
        }}
      >
        <Box
          sx={{
            width: 134,
            height: 5,
            backgroundColor: '#000',
            borderRadius: 2.5,
          }}
        />
      </Box>
    </Box>
  );
}
